import type { PutAccountEditRequest, PutAccountEditResponse } from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const putAccountEdit = sendRequest<PutAccountEditRequest, PutAccountEditResponse>({
  url: '/account/edit',
  method: 'put',
});
